
import React from 'react';
import ZUtil from './zutil';
import ZProps from './zprops';
import AMCStripeCheckoutButton from './AMCStripeCheckout';
//import AMCPlans from './AMCPlans';
import AMC from "./AMC";
import { APP } from "./App";
import { ZooComputeUpgrades } from "./ZooProfilePage";
import PleaseStandBy from "./PleaseStandBy";
import { ROUTER } from './AMCRouter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'

export default class AMCPlansAndPricingPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = { monthly: true };
	}
	componentDidMount() {
		AMC.getPricingPlans((err, plans) => {
			if (!err) {
				this.setState({ plans: plans });
			} else {
				this.setState({ error: err });
			}
		});
	}
	onPaymentIntervalChange(which) {
		this.setState({ monthly: which === "monthly" });
	}
	onOrderComplete = () => {
		this.forceUpdate();
	}
	purchaseBatteryPacks = () => {
		APP.showPopup(<ZooComputeUpgrades caller={this} />);
	}
	render() {
		let { plans, monthly } = this.state;
		if (!plans) {
			return <PleaseStandBy />;
		}
		let user = ZProps.get("user");
		let msgs = [];
		let labels = "join,join,join,join,join";
		if (user.plan === "member") {
			labels = ",upgrade,upgrade,upgrade,upgrade";
			msgs[0] = "thank you!";
		} else if (user.plan === "premium") {
			labels = ",,upgrade,upgrade,upgrade";
			msgs[1] = "thank you!";
		} else if (user.plan === "pro") {
			labels = ",,,upgrade,upgrade";
			msgs[2] = "thank you!";
		} else if (user.plan === "rockstar") {
			labels = ",,,,upgrade";
			msgs[3] = "thank you!";
		} else if (user.plan === "business") {
			labels = ",,,,";
			msgs[4] = "thank you!";
		}
		labels = labels.split(",");
		// let uris = "join,member,premium,pro,business".split(",");
			//{ name: "Ninja (site) bot", values: "y,y,y,y,y" },
		let FEATURES = [
			{ name: "Demonstrations", values: "y,y,y,y,y,y" },
			{ name: "Consume services", values: "y,y,y,y,y,y" },
			{ name: "Freakouts, WTFs and HelpMeChoose", values: "y,y,y,y,y,y" },
			{ name: "Likes, Dislikes", values: "y,y,y,y,y,y" },
			{ name: "Rockstar IDE", values: "n,y,y,y,y,y" },
			{ name: "Build services", values: "n,y,y,y,y,y" },
			{ name: "Build models", values: "n,y,y,y,y,y" },
			{ name: "Build algorithms", values: "n,y,y,y,y,y" },
			{ name: "Deploy services", values: "n,y,y,y,y,y" },
			{ name: "Deploy demos", values: "n,y,y,y,y,y" },
			{ name: "Unlimited public projects", values: "n,y,y,y,y,y" },
			{ name: "Unlimited private projects", values: "n,n,y,y,y,y" },
			{ name: "Commenting", values: "n,n,y,y,y,y" },
			{ name: "Star'ing", values: "n,n,y,y,y,y" },
			{ name: "Kudos'ing", values: "n,n,y,y,y,y" },
			{ name: "Consume premium services", values: "n,n,y,y,y,y" },
			{ name: "Purchase battery packs", values: "n,n,y,y,y,y" },
			{ name: "GPU access (Fall '20)", values: "n,n,n,y,y,y" },
			{ name: "Priority GPU access (Fall '20)", values: "n,n,n,n,y,y" },
			{ name: "Early feature access (Fall '20)", values: "n,n,n,n,y,y" },
			{ name: "Branded components and services", values: "n,n,n,n,n,y" },
			{ name: "Organizations (Teams)", values: "n,n,n,n,n,y" },


		];
		plans = plans.subscriptions;
		let interval = monthly ? "monthly" : "yearly";
		return (
			<div className="AMCPlansAndPricingPage">
				<div className="AMCPlansAndPricingPageCTA">
					<p>We are... the rest of us</p>
<p>We are 20M developers who perhaps don't get paid to work on A.I. but still want to incorporate machine intelligence into the software we write as well as make sure that everyone, everywhere benefits from this new technology</p>
	<p>We are 30M businesses who perhaps can't afford huge data science divisions but still want to incorporate machine intelligence into our business - to help improve the products and services we sell and the quality of our customer's lives</p>
	<p>We are 7B people who aren't always sure exactly what A.I. is but still want it to improve the quality of life of our families, ourselves, and the world at large.</p>
					<p>Care to join us?</p>
				</div>
				<h1>Plans and Pricing</h1>
{/*
				<div className="AMCPlansTableMonthlyYearly">
					<button className={monthly ? "AMCPlansTableMonthlyYearlySelected" : ""} onClick={this.onPaymentIntervalChange.bind(this, "monthly")}>{monthly ? <FontAwesomeIcon icon={faCheck} /> : ''} Monthly</button>
					<button className={monthly ? "" : "AMCPlansTableMonthlyYearlySelected"} onClick={this.onPaymentIntervalChange.bind(this, "yearly")}>{monthly ? '' : <FontAwesomeIcon icon={faCheck} />} Yearly</button>
				</div>
*/}
				<div className="AMCPlansTable">
					<table><tbody>
					<tr>
						<th> </th>
						<th> 
							<h2>Guest</h2>
							<div className="AMCPlansTablePrice">free</div>
						</th>
						<th> 
							<h2>Member</h2>
							<div className="AMCPlansTablePrice">FREE</div>
							{ labels[0] ? <button type="submit" class="AMCPlansTablePriceButton"><a href={"/-/signup"} onClick={ROUTER.pushRoute.bind(ROUTER, "/-/signup")}>{labels[0]}</a></button> : <span className="AMCPlansTableHeaderThanks">{msgs[0]}</span> }
						</th>
						{ plans.map( (p, index) => {
							let plan = p[interval];
							return <th key={plan.level}>
									<h2>{p.monthly.level}</h2> 
									<div className="AMCPlansTablePrice">${ZUtil.toPrice(monthly ? plan.pricing : plan.pricing/12)}</div>
{/*									<div className="AMCPlansTableSubSubheader">${ZUtil.toPrice(p.yearly.pricing/12)} per month billed annually, or ${ZUtil.toPrice(p.monthly.pricing)} billed monthly, plus ${ZUtil.toPrice(plan.compute_pricing)}/compute*</div> */}
									<div className="AMCPlansTableSubSubheader">{p.monthly.level === "business" ? "" : ""} per month</div>
									{ labels[index + 1] ? <AMCStripeCheckoutButton label={labels[index + 1]} plan={plan} caller={this} /> : <span className="AMCPlansTableHeaderThanks">{msgs[index + 1]}</span> }
							</th>
						})}
					</tr>
					<tr>
						<td>Computes* included in price</td>
						<td>2/day</td>
						<td>2/day</td>
						<td>100/month</td>
						<td>3000/month</td>
						<td>10000/month</td>
						<td>10000/month</td>
					</tr>
					{ FEATURES.map( feature => { 
						let values = feature.values.split(",");
						return (
							<tr key={feature.name} >
								<td>{feature.name}</td>
								{ values.map( (v, index) => {
									return <td key={feature.name + v + index} className={v === "y" ? "AMCPlansFeatureYes" : "AMCPlansFeatureNo"}>{v === "n" ? <FontAwesomeIcon icon={faTimes} /> : (v === "y" ? <FontAwesomeIcon icon={faCheck} /> : v)}</td>
								} ) }
							</tr>
						)
					} )}
					</tbody></table>
				</div>

			<div className="AMCPlansDetails">
				* Computes are non-redeemable. Non-returnable. Non-transferable. Unused plan computes expire at the end of each subscription month. Unused battery pack computes expire after 365 days. One compute is enough for approximately one 200 epoch NMIST training. Additional computes can be purchased by ordering extra battery packs.
			</div>
			<div className="AMCPlansAndPricingPageBatteryPacks">
				<h2>Battery Packs</h2>
				<p>Battery packs allow you to add extra compute time while still keeping your monthly membership plan the same.</p>
				<h3 className="AMCPlansPurchaseBatteryPacks" onClick={this.purchaseBatteryPacks}>Purchase Battery Packs</h3>
			</div>
			</div>
		)
	}
}





// WEBPACK FOOTER //
// ./src/AMCPlansAndPricingPage.js